
import Vue from 'vue'
import Router from 'vue-router'
import SurgicalCases from '../views/SurgicalCases.vue'
import SurgicalCase from '../views/SurgicalCase.vue'
import TreatmentPlanRequestDetails from '../views/TreatmentPlanRequestDetails.vue'
import SurgicalCaseForm from '../views/SurgicalCaseForm.vue'
import SurgicalCasesCardView from '../views/SurgicalCasesCardView.vue'
import SurgeonPreferences from '../views/SurgeonPreferences.vue'
import TreatmentPlanRequests from '../views/TreatmentPlanRequests.vue'
import Callback from '../views/Callback.vue'
import PatientScans from '../views/PatientScans.vue'
import SignIn from '../views/SignIn.vue'
import ComponentReference from '../views/ComponentReference.vue'
import AdminArea from '../views/AdminArea.vue'
import AdminAreaBranchDetail from '../views/AdminAreaBranchDetail.vue'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/common/oauth2/logout',
      name: 'msLogout',
      beforeEnter() { location.href = `https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=${encodeURIComponent(router.app.$redirectUri)}/logoff` }
    },
    {
      path: '/Callback',
      name: 'callback',
      component: Callback,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/SurgicalCases',
      name: 'surgicalCases',
      component: SurgicalCases,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser'
        ]
      }
    },
    {
      path: '/SurgicalCaseForm',
      name: 'surgicalCaseForm',
      component: SurgicalCaseForm,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser'
        ]
      }
    },
    {
      path: '/SurgicalCase',
      name: 'surgicalCase',
      component: SurgicalCase,
      props: true,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser'
        ]
      }
    },
    {
      path: '/TreatmentPlanRequestDetails',
      name: 'treatmentPlanRequestDetails',
      component: TreatmentPlanRequestDetails,
      props: true,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser',
          'RH.MS.InhouseUser'
        ]
      }
    },
    {
      path: '/SurgicalCasesCardView',
      name: 'surgicalCasesCardView',
      component: SurgicalCasesCardView,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser'
        ]
      }
    },
    {
      path: '/SurgeonPreferences',
      name: 'surgeonPreferences',
      component: SurgeonPreferences,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser'
        ]
      }
    },
    {
      path: '/TreatmentPlanRequests',
      name: 'treatmentPlanRequests',
      component: TreatmentPlanRequests,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser',
          'RH.MS.InhouseUser'
        ]
      }
    },
    {
      path: '/PatientScans',
      name: 'patientScans',
      component: PatientScans,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.FieldUser'
        ]
      }
    },
    {
      path: '/AdminArea',
      name: 'adminArea',
      component: AdminArea,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.AdminUser'
        ]
      }
    },
    {
      path: '/AdminAreaBranchDetail',
      name: 'adminAreaBranchDetail',
      component: AdminAreaBranchDetail,
      props: true,
      meta: {
        requireAuth: true,
        requireRoles: [
          'RH.MS.AdminUser'
        ]
      }
    },
    {
      path: '/ComponentReference',
      name: 'ComponentReference',
      component: ComponentReference,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/SignIn',
      name: 'SignIn',
      component: SignIn,
      props: true,
      meta: {
        requireAuth: false
      }
    }
  ]
})
router.beforeResolve(async (to, from, next) => {
  if (to.path === "/logoff") router.app.$msal.signOut()
  if (to.path === "/") router.replace({ name: 'callback' });
  if (to.path === "/SignIn" && router.app.$msal.isAuthenticated()) router.replace({ name: 'callback' });
  // Check if route needs authentication
  if (to.matched.some(record => record.meta.requireAuth)) {
    // Check if authenticated
    if (router.app.$msal.isAuthenticated()) {
      // Authenticated, make sure roles are okay
      let roles = await store.getters.getRoles
      if (typeof roles === 'string') {
        roles = [roles]
      }
      // If roles are required
      if (to.meta.requireRoles) {
        // If one of the required roles is set => go on
        if (to.meta.requireRoles.some(r => roles.includes(r))) {
          next()
          // If the roles are still loading, try again
        } else if (JSON.parse(JSON.stringify(roles)).length == 0) {
          next(to.fullPath)
          // Otherwise redirect to surgical cases
        } else {
          next(from.fullPath)
        }
        // No specific roles required => go on
      } else {
        next()
      }
    } else {
      // not logged in, forward to SignIn (if not there already)
      if (from.name !== "SignIn") {
        router.replace({ name: 'SignIn' });
      } else {
        next(from.fullPath)
      }
    }
    // No Authorization required => go on
  } else {
    next()
  }
})

export default router